var _rect, _path, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMaintenance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000366211,
    width: 13,
    height: 11.6316,
    rx: 1.5,
    fill: "#8D939C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49985 4.10559C4.80214 4.10559 3.4209 5.48684 3.4209 7.18454C3.4209 8.88224 4.80214 10.2635 6.49985 10.2635C8.19755 10.2635 9.57879 8.88224 9.57879 7.18454C9.57879 5.48684 8.19755 4.10559 6.49985 4.10559ZM6.8077 7.18454C6.8077 7.2112 6.80239 7.23792 6.79189 7.26293C6.78145 7.28818 6.76642 7.31077 6.74736 7.32983L5.26827 8.84137C5.20525 8.90439 5.06073 8.93877 4.90317 8.78121C4.8229 8.70094 4.8229 8.57123 4.90317 8.49096L6.29462 7.09951V5.13191C6.29462 5.01861 6.38872 4.94888 6.49989 4.92665C6.64158 4.89832 6.8077 4.9677 6.80774 5.13191L6.8077 7.18454Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.00037,
    width: 11,
    height: 2,
    rx: 0.4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.70037C2 1.58991 2.08954 1.50037 2.2 1.50037H2.8C2.91046 1.50037 3 1.58991 3 1.70037V2.30037C3 2.41082 2.91046 2.50037 2.8 2.50037H2.2C2.08954 2.50037 2 2.41082 2 2.30037V1.70037Z",
    fill: "#8D939C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 1.70037C3.79999 1.58991 3.88953 1.50037 3.99999 1.50037H4.59999C4.71044 1.50037 4.79999 1.58991 4.79999 1.70037V2.30037C4.79999 2.41082 4.71044 2.50037 4.59999 2.50037H3.99999C3.88953 2.50037 3.79999 2.41082 3.79999 2.30037V1.70037Z",
    fill: "#8D939C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60001 1.70037C5.60001 1.58991 5.68955 1.50037 5.80001 1.50037H6.40001C6.51046 1.50037 6.60001 1.58991 6.60001 1.70037V2.30037C6.60001 2.41082 6.51046 2.50037 6.40001 2.50037H5.80001C5.68955 2.50037 5.60001 2.41082 5.60001 2.30037V1.70037Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMaintenance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_maintenance.9c155c7a255be4d3b356cbc70fab2fc6.svg";